import styled from "styled-components";
import { display, layout, space, typography, position } from "styled-system";

export const Box = styled.div`
  ${layout};
  ${space};
  ${display};
  ${typography};
  ${position};
`;
